import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import { useNavigate } from "react-router-dom";
import "../HomeScreenDetail/Style.css";
import {
  postAPICall,
  putAPICall,
  DeleteAPICall,
  showToast,
  setToastRef,
  showSuccessToast,
} from "../Api/Api";

import { IoAddOutline } from "react-icons/io5";
import { MdDragIndicator, MdModeEdit } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import GlobalPopup from "../GlobalComponents/GlobalPopup";
import { useLoader } from "../GlobalComponents/Loader";

const PlaylistScheduleHeader = (props) => {
  const [PlaylistScheduleHead, setPlaylistScheduleHead] = useState([]);
  const [mediaSizeMb, setMediaSizeMb] = useState(0);
  const [schadd, setschadd] = useState(false);
  const [schdrag, setschdrag] = useState(false);
  const [loading, setLoading] = useState(true);
  localStorage.setItem("Playdata", PlaylistScheduleHead);
  const SchId = localStorage.getItem("SchId");
  const toast = useRef(null);
  //loaderconst
  const [showDialog, setShowDialog] = useState(false);
  const [editedSCHHeaderData, setEditePlaylistEdit] = useState(null);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [SelectSChHeader, setSelectedPlayListSCHHeader] = useState(null);
  const [PlayListSchHeaderValid, setSheduleHeaderValid] = useState(true);
  const [TexBoxValidation, SetTexboxValidation] = useState(true);
  const [NewPlySchHeaderData, setNewPlayListSchHeaderData] = useState({});
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [SeletedValue, setDeletedValue] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedRowValue, setSelectedRowValue] = useState(true);
  const [TotalDuration, setTotalDuration] = useState("00:00:00");
  const { showLoader, hideLoader } = useLoader();

  useEffect(() => {
    setToastRef(toast.current);
    if (props?.selectednewid) {
      props?.selectednewid && fetchPlaylistHeader();
    }
  }, [
    props,
    props?.selectednewid,
    props?.UpdatedDurationParam, //Deuration Render
  ]);
  //GetScheduleHeader Get Api Call
  const fetchPlaylistHeader = async () => {
    showLoader();
    let stringconversion = props?.selectednewid || "";
    let stringModuleName = props?.selectednewName || "";
    //schedule add button Visivle false
    stringModuleName === "Schedule" ? setschadd(false) : setschadd(true);
    stringModuleName === "Schedule"
      ? setschdrag("schgroup")
      : setschdrag(false);
    let AccountGroupCode = localStorage.getItem("AccountGroupCode");
    const requestBody = {
      companyID: stringconversion,
      AccountGroupCode: AccountGroupCode,
    };
    const response = await postAPICall(
      "api/PlayLists/GetScheduleHeader",
      requestBody
    );
    if (response?.status === 200) {
      hideLoader();
      setLoading(false);
      setPlaylistScheduleHead(response?.data);

      const formatNumber = (number) => {
        return number < 10 ? `0${number}` : `${number}`;
      };

      let sum = response.data.reduce((acc, item) => {
        const [hours, minutes, seconds] = item.Duration.split(":");
        acc +=
          parseInt(hours) * 3600 + parseInt(minutes) * 60 + parseInt(seconds);
        return acc;
      }, 0);
      const hours = Math.floor(sum / 3600);
      const minutes = Math.floor((sum % 3600) / 60);
      const seconds = sum % 60;
      const TotalDurationtime = `${formatNumber(hours)}:${formatNumber(
        minutes
      )}:${formatNumber(seconds)}`;

      setTotalDuration(TotalDurationtime);

      const totalSizeCalculation = response.data.reduce((acc, item) => {
        return acc + (parseInt(item.MediaSize) || 0); // Ensure to handle missing or undefined mediaSizeMB
      }, 0);
      setMediaSizeMb(totalSizeCalculation);
    } else {
      setPlaylistScheduleHead([]);
    }
    hideLoader();
  };

  //clg changes
  const onSelectionChange = (e) => {
    setSelectedRowValue(e.value);
    localStorage.removeItem("SchId");
    if (props.HideDragIcon == "HideDragIcon") {
      props.onclickcheck(e.value);
    }
  };
  //Delete Event
  const deletescheduleheader = async (e) => {
    setDeletedValue(e);
    setDeleteConfirmation(true);
  };
  //Row Double click to navigate
  let navigate = useNavigate();
  const onRowDblClick = (e) => {
    let stringconversion = e.data.ScheduleHdrId;
    localStorage.setItem("SchId", stringconversion);
    localStorage.setItem("SchName", e.data.Schedulename);
    navigate("/playlist");
  };
  //Edit Icon click to Show popup
  const handleEdit = (rowData) => {
    setSelectedPlayListSCHHeader(rowData);
    setEditDialogVisible(true);
    setEditePlaylistEdit({ ...rowData });
  };
  //Show Edit and Delete Icon And Event
  const actionBodyTemplate = (rowData) => {
    return (
      <div className="datatable-row-action">
        <Button
          hidden={props.HideDragIcon ? false : true}
          id="LibraryGridDeleteIcon"
          icon={<MdModeEdit />}
          title="Edit"
          className="p-button-rounded"
          onClick={() => handleEdit(rowData)}
        />
        <Button
          hidden={props.HideDragIcon ? false : true}
          id="LibraryGridDeleteIcon"
          title="Delete"
          icon={<MdDelete />}
          onClick={() => deletescheduleheader(rowData)}
        />
      </div>
    );
  };
  //Drag and Drop
  const onDragStart = (e, rowdata) => {
    e.dataTransfer.setData("text/plain", JSON.stringify(rowdata));
    props.onclickcheck(rowdata);
  };
  //Editinf Value Get And Store Usestate
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditePlaylistEdit((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  //Edit APi Call
  const handleSubmitEdit = async (e) => {
    const requestBody = {
      ScheduleHdrId: editedSCHHeaderData.ScheduleHdrId,
      ScheduleHeaderName: editedSCHHeaderData.Schedulename,
    };
    const response = await putAPICall(
      "api/PlayLists/PutScheduleHeader",
      requestBody
    );
    fetchPlaylistHeader();
    setEditDialogVisible(false);
    showSuccessToast("Updated...");
  };

  //New PlayListScheduleHeader add Show popup
  const openNew = () => {
    setShowDialog(true);
  };
  // New Add Post Api call
  const handleNewSubmit = async () => {
    if (!NewPlySchHeaderData.Schedulename) {
      SetTexboxValidation(false);
      return; // Exit early if the text box is empty
    }

    let AccountGroupCode = localStorage.getItem("AccountGroupCode");
    const requestBody = {
      companyID: "1",
      scheduleHeaderName: NewPlySchHeaderData.Schedulename,
      AccountGroupCode: AccountGroupCode,
    };
    const response = await postAPICall(
      "api/PlayLists/PostScheduleHeader",
      requestBody
    );
    fetchPlaylistHeader();
    setShowDialog(false);
    showSuccessToast("Added Successfully");
  };
  //popup Save Cancel Button
  const PlaylistScheduleHeaderAdd = (
    <div>
      <Button
        id="BtnSave"
        label="Save"
        icon="pi pi-check"
        onClick={handleNewSubmit}
        autoFocus
      />
      <Button
        id="BtnCancel"
        label="Cancel"
        icon="pi pi-times"
        onClick={() => setShowDialog(false)}
        className="p-button-text"
      />
    </div>
  );
  const PlaylistScheduleHeaderAddContent = (
    <div className="p-fluid" style={{ padding: "10px" }}>
      <div className="p-field">
        <InputText
          // id="Schedulename"
          value={NewPlySchHeaderData.Schedulename || ""}
          onChange={(e) => handleNewInputChange(e, "Schedulename")}
          onBlur={() => SetTexboxValidation(!!NewPlySchHeaderData.Schedulename)}
          className={!TexBoxValidation ? "p-invalid" : ""}
        />
      </div>
    </div>
  );
  //Get add Button Click to New Value and Stored usesate
  // Get add Button Click to New Value and Stored usestate
  const handleNewInputChange = (e, field) => {
    const value = e.target.value;
    setNewPlayListSchHeaderData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };
  const confirmDelete = async () => {
    const requestBodydelete = {
      companyID: "1",
      scheduleHeaderID: SeletedValue.ScheduleHdrId,
    };
    const response = await DeleteAPICall(
      "api/PlayLists/DeleteScheduleHeader",
      requestBodydelete
    );
    fetchPlaylistHeader();
    setDeleteConfirmation(false);
    showSuccessToast("Schedule header Deleted...");
  };
  //Search Event
  const filteredData = PlaylistScheduleHead?.filter((PlaylistScheduleHead) =>
    PlaylistScheduleHead.Schedulename.toLowerCase().includes(
      searchQuery.toLowerCase()
    )
  );
  useEffect(() => {
    if (SchId && filteredData.length > 0) {
      const SchIdNumber = parseInt(SchId, 10);
      const defaultSelectedRow = filteredData.find(
        (row) => row.ScheduleHdrId === SchIdNumber
      );
      if (defaultSelectedRow) {
        setSelectedRowValue(defaultSelectedRow);
      }
    }
  }, [filteredData]);
  const PlaylistScheduleHeaderEdit = (
    <div>
      <Button
        label="Submit"
        id="BtnSave"
        icon="pi pi-check"
        onClick={handleSubmitEdit}
        autoFocus
      />
      <Button
        id="BtnCancel"
        label="Cancel"
        icon="pi pi-times"
        onClick={() => setEditDialogVisible(false)}
        className="p-button-text"
      />
    </div>
  );
  const PlaylistScheduleHeaderContent = (
    <div className="p-fluid" style={{ padding: "10px" }}>
      <div className="p-field">
        <InputText
          // id="Schedulename"
          name="Schedulename"
          value={editedSCHHeaderData?.Schedulename}
          onChange={handleInputChange}
          onBlur={() =>
            setSheduleHeaderValid(!!editedSCHHeaderData?.Schedulename)
          }
          className={!PlayListSchHeaderValid ? "p-invalid" : ""}
        />
      </div>
    </div>
  );
  const PlaylistScheduleHeaderDelete = (
    <div>
      <Button
        style={{ borderRadius: "5px", padding: "15px" }}
        label="Yes"
        icon="pi pi-check"
        onClick={confirmDelete}
        autoFocus
      />
      <Button
        style={{
          borderRadius: "5px",
          padding: "15px",
          backgroundColor: "lightslategray",
          color: "white",
        }}
        label="No"
        icon="pi pi-times"
        onClick={() => setDeleteConfirmation(false)}
        className="p-button-text"
      />
    </div>
  );

  return (
    <div className="datatable-responsive">
      <Toast ref={toast} />
      <div
        id="plus_search"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <Button
          icon={
            <IoAddOutline
              style={{ color: "darkslategrey", fontSize: "50px" }}
            />
          }
          id="MasterPlusicon"
          onClick={() => setShowDialog(true)}
          className="p-button p-button-icon"
          title="Add"
        />
        <InputText
          id="PlaylistHeaderSearch"
          type="search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search..."
        />
        <Button
          icon="pi pi-search"
          id="searchicon"
          style={{
            backgroundColor: "lightslategray",
            border: "lightslategray",
          }}
          className="p-button-primary"
          title="Search"
        />
      </div>

      {loading ? (
        <ProgressSpinner
          style={{ width: "50px", height: "30px", marginTop: "230px" }}
          strokeWidth="3"
        />
      ) : (
        <DataTable
          value={filteredData}
          selectionMode="single"
          selection={selectedRowValue}
          onSelectionChange={onSelectionChange}
          // onSelectionChange={(e) => onSelectionChange(e)}
          onRowDoubleClick={(e) => onRowDblClick(e)}
          dataKey="ScheduleHdrId"
          scrollable
          scrollHeight="70vh"
          rowClassName={(rowData) =>
            selectedRowValue &&
            selectedRowValue.ScheduleHdrId === rowData.ScheduleHdrId
              ? "selected-row"
              : ""
          }
          // paginator
          // rows={10}
        >
          <Column
            style={{ width: "2px" }}
            hidden={props.HideDragIcon ? true : false}
            body={(rowdata) => (
              <div draggable onDragStart={(e) => onDragStart(e, rowdata)}>
                <Button
                  id="PlayListScheduleHeaderDragIcon"
                  icon={<MdDragIndicator />}
                  title="Drag"
                ></Button>
              </div>
            )}
          ></Column>
          <Column
            field="Schedulename"
            header="Schedule Name"
            sortable
            className="text-ellipsis"
            body={(rowData, index) => (
              <span title={rowData?.Schedulename}>{rowData?.Schedulename}</span>
            )}
          />
          <Column
            field="Duration"
            header="Duration"
            sortable
            // hidden={props.HideDragIcon ? false : true}
          />
          <Column
            field="MediaSize"
            header="MediaSize"
            sortable
            // hidden={props.HideDragIcon ? false : true}
          />
          <Column body={actionBodyTemplate} />
        </DataTable>
      )}
      <div
        style={{ display: "flex", gap: "115px" }}
        hidden={props.HideDragIcon ? true : false}
      >
        <b>Total Size(MB): {mediaSizeMb}</b>
        <b> Duration: {TotalDuration}</b>
      </div>
      <GlobalPopup
        title={"Edit Schedule Header Name"}
        visible={editDialogVisible}
        onHide={() => setEditDialogVisible(false)}
        footerButtons={PlaylistScheduleHeaderEdit}
        content={PlaylistScheduleHeaderContent}
      />
      <GlobalPopup
        title="Schedule Header Name"
        visible={showDialog}
        onHide={() => setShowDialog(false)}
        footerButtons={PlaylistScheduleHeaderAdd}
        content={PlaylistScheduleHeaderAddContent}
      />
      <GlobalPopup
        title="Confirmation"
        visible={deleteConfirmation}
        onHide={() => setDeleteConfirmation(false)}
        footerButtons={PlaylistScheduleHeaderDelete}
        content={
          <div className="confirmation-content">
            <br />
            <h6>Are you sure you want to delete this Data ?</h6>
          </div>
        }
      />
    </div>
  );
};

export default PlaylistScheduleHeader;
